import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const cancelLeaveAudit = listeners["cancelLeaveAudit"] || function () { };
  const toEdit = listeners["toEdit"] || function () { };
  const auditDetail = listeners["auditDetail"] || function () { };

  const canEdit = [2, 3, 4, 5]; // 审核状态（0审核中 1审核通过 2审核不通过 3已撤销 4撤销审核中 5撤销不通过）

  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    const auditStatus = Number(curItem.auditStatus)
    const editFlag = canEdit.includes(auditStatus)
    const cancelFlag = !canEdit.includes(auditStatus)
    let dealConf = [];

    // 请假数据来源（1网院  2党校）
    if (curItem.dataSource !== 2) {
      // 编辑按钮暂时废弃
      // dealConf.push([
      //   editFlag ? "icon-edit" : "icon-edit-disable",
      //   "编辑",
      //   () => {
      //     editFlag && curItem.dateSource !== 2 && toEdit(curItem)
      //   },
      //   "enrollment:saveOrUpdate,enrollment:info"
      // ]);
      dealConf.push([
        cancelFlag ? "iconfont ic_withdrawalofleave iconfont-adapt" : "iconfont ic_withdrawalofleave iconfont-adapt-disabled",
        "撤销",
        () => {
          cancelFlag && cancelLeaveAudit(curItem)
        },
        "audit:leave:cancel"
      ]);
    }
    dealConf.push(["icon-audit-detail", "审核详情", () => auditDetail(curItem), "audit:leave:list"])
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      width: "110"
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "开始时间",
      prop: "leaveStartTimeName",
      width: "150"
    },
    {
      label: "结束时间",
      prop: "leaveEndTimeName",
      width: "150"
    },
    {
      label: "时长（天）",
      prop: "leaveDays",
      width: "90"
    },
    {
      label: "请假类型",
      prop: "leaveTypeName",
      width: "80"
    },
    {
      label: "申请事由",
      prop: "auditNotes",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      width: "80"
    },
    {
      label: "提交时间",
      prop: "createDate",
      width: "160"
    },
    {
      label: "操作",
      width: "120",
      // fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
